import { render, staticRenderFns } from "./IntellectualProperty.vue?vue&type=template&id=6020b6f8&scoped=true"
import script from "./IntellectualProperty.vue?vue&type=script&lang=js"
export * from "./IntellectualProperty.vue?vue&type=script&lang=js"
import style0 from "./IntellectualProperty.vue?vue&type=style&index=0&id=6020b6f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6020b6f8",
  null
  
)

export default component.exports